export default function Content() {
    multiArtliceBlock()
    columnBlock()
    responsiveTable()
    setChipUrl()
    scrollToAnchor()
}

function multiArtliceBlock() {

    var element = document.querySelectorAll('.equal-height');
    var targetHeight = equalHeight('.equal-height');

    for (var i = 0; i < element.length; i++) {
        element[i].style.height = targetHeight + "px";
    }
}

function responsiveTable() {

    var tables = document.querySelectorAll(".rte-content table");
    
    for (var i = 0, len = tables.length; i < len; i++) {

        var wrapper = document.createElement('div');
        wrapper.className = "repsonsive-table";

        tables[i].parentNode.insertBefore(wrapper, tables[i]);
        wrapper.appendChild(tables[i]);
    }
}

function columnBlock() {
    var carouselElement = document.querySelectorAll('.colour-subcategory .colour-carousel');
    var carouselTargetHeight = equalHeight('.colour-subcategory .colour-carousel');

    if (carouselElement != undefined) {
        for (var j = 0; j < carouselElement.length; j++) {
            carouselElement[j].style.height = carouselTargetHeight + "px";
        }
    }

    var element = document.querySelectorAll('.column-height');
    var targetHeight = equalHeight('.column-height');

    for (var i = 0; i < element.length; i++) {
        element[i].style.height = targetHeight + "px";
    }
}

function equalHeight(className) {
    var max = 0;
    document.querySelectorAll(className).forEach(
        function (el) {
            
            if (el.offsetHeight > max) {
                max = el.offsetHeight;
            }
        }
    );

    return max;
}

export function setChipUrl() {
    const colourChip = document.querySelectorAll('.colour-chip-url');

    for (var i = 0; i < colourChip.length; i++) {

        colourChip[i].addEventListener('click', function (e) {
            e = window.event || e;

            if (this === e.target) {
                let url = this.getAttribute("data-url");

                if (url != "" && url != "null") {
                    window.location.href = url;
                }
            }

        });
    }
}

function scrollToAnchor() {
    const anchorLinks = document.querySelectorAll('.js-button-anchor');
    const header = document.querySelector('header');
    const HEADER_OFFSET = 120;

    anchorLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            let elementMoveTo = e.target.hash;
            let elementMoveToNode = document.querySelector(elementMoveTo);
            if (!elementMoveToNode) return;

            let headerOffset = (typeof (header) != 'undefined' && header != null) ? HEADER_OFFSET : 0;
            let scrollOffset = elementMoveToNode.getBoundingClientRect().top - headerOffset;
            window.scrollTo({
                top: scrollOffset,
                behavior: 'smooth'
            })
        })
    });
}